// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.market.marketpage.handler.RentalGrowthMedianRentByBedroomWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetMedianRentByBedroomRequestDto, GetMedianRentByBedroomResponseDto } from '../..';

export const RentalGrowthMedianRentByBedroomWebApiHandler_medianRentByBedroom_Path =
  '/api/web/v1/marketTrends/medianRentByBedroom';

export const RentalGrowthMedianRentByBedroomWebApiHandler_medianRentByBedroom = (
  postData: GetMedianRentByBedroomRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetMedianRentByBedroomRequestDto, GetMedianRentByBedroomResponseDto>(
    {
      endpoint: RentalGrowthMedianRentByBedroomWebApiHandler_medianRentByBedroom_Path,
      method: 'POST',
      contextPath: '/rental-growth-api',
      postData: postData,
    },
    client,
  );
};
